import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Axios from 'axios';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";

const AddNewPermitTypePrice = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const permitTypeId = parseInt(searchParams.get('id'), 10);
    const [days, setDays] = useState('');
    const [price, setPrice] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', type: '' });
    const [pricingData, setPricingData] = useState([]);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [editingRowId, setEditingRowId] = useState(null);
    const [editDays, setEditDays] = useState('');
    const [editPrice, setEditPrice] = useState('');
    const buttonStyle = {
        width: '100px',
        margin: '0 5px',
    };

    const startEditing = (id, days, price) => {
        setEditingRowId(id);
        setEditDays(days);
        setEditPrice(price);
    };

    const handleSave = async (id) => {
        try {
            const { data } = await Axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdatePermitTypePrice`, {
                id: id,
                permitTypeId: permitTypeId,
                days: parseInt(editDays, 10),
                price: editPrice,
            });
            if (data.success) {
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
                setEditingRowId(null);
                void fetchData();
            } else {
                setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
            }
        } catch (error) {
            setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
        }
    };

    const handleDeleteRequest = (id) => {
        setDeleteItemId(id);
        setShowDeleteConfirmation(true);
    };

    const handleDeleteConfirm = async () => {
        if (deleteItemId == null) return;

        try {
            const { data } = await Axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeletePermitTypePrice`, {
                id: deleteItemId,
                delete: true,
            });
            if (data.success) {
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
                void fetchData();
            } else {
                setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
            }
        } catch (error) {
            setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
        }

        setShowDeleteConfirmation(false);
        setDeleteItemId(null);
    };


    useEffect(() => {
        setIsSubmitDisabled(!days || !price);
    }, [days, price]);

    const fetchData = async () => {
        try {
            const { data } = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypePricings`);
            if (data.success) {
                const filteredData = data.data.filter(item => item.permitId === permitTypeId);
                setPricingData(filteredData);
            } else {
                setAlert({ show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error' });
            }
        } catch (error) {
            setAlert({ show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error' });
        }
    };

    useEffect(() => {
        void fetchData();
    }, [permitTypeId]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!days || !price) {
            setAlert({ show: true, message: 'დღეები და ფასი ველები აუცილებლად უნდა შეივსოს', type: 'error' });
            return;
        }
        setShowConfirmationModal(true);
    };

    const handleConfirm = async () => {
        const dataToSend = {
            permitTypeId,
            days: parseInt(days, 10),
            price: price,
        };

        try {
            const { data } = await Axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewPermitTypePrice`, dataToSend);
            if (data.success) {
                setAlert({ show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success' });
                resetForm();
                void fetchData();
            } else {
                setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
            }
        } catch (error) {
            setAlert({ show: true, message: 'დაფიქსირდა შეცდომა', type: 'error' });
        }

        setShowConfirmationModal(false);
    };


    const resetForm = () => {
        setDays('');
        setPrice('');
    };

    const handleCloseAlert = () => {
        setAlert({ ...alert, show: false });
    };
    const cancelEdit = () => {
        setEditingRowId(null);
        setEditDays('');
        setEditPrice('');
    };

    return (
        <>
            <Paper elevation={3} style={{ padding: '20px', margin: '20px auto', maxWidth: '600px' }}>

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="დღეები"
                                type="number"
                                value={days}
                                onChange={(e) => setDays(e.target.value)}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="პირობა"
                                type="text" // Changed from number to text
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button type="submit" variant="contained" color="primary" fullWidth disabled={isSubmitDisabled}>
                                დამატება
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <TableContainer component={Paper} style={{ margin: '20px auto', maxWidth: '800px', width: '90%' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="right">დღეები</TableCell>
                            <TableCell align="right">პირობა</TableCell>
                            <TableCell align="right">ქმედება</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {pricingData.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell align="right">
                                    {editingRowId === row.id ? (
                                        <TextField
                                            size="small"
                                            type="number"
                                            value={editingRowId === row.id ? editDays : row.days}
                                            onChange={(e) => setEditDays(e.target.value)}
                                        />
                                    ) : (
                                        row.days
                                    )}
                                </TableCell>
                                <TableCell align="right">
                                    {editingRowId === row.id ? (
                                        <TextField
                                            size="small"
                                            type="text"
                                            value={editingRowId === row.id ? editPrice : row.price}
                                            onChange={(e) => setEditPrice(e.target.value)}
                                        />
                                    ) : (
                                        `${row.price} `
                                    )}
                                </TableCell>
                                <TableCell align="right">
                                    {editingRowId === row.id ? (
                                        <>
                                            <Button
                                                style={buttonStyle}
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleSave(row.id)}
                                            >
                                                შენახვა
                                            </Button>
                                            <Button
                                                style={buttonStyle}
                                                variant="outlined"
                                                color="secondary"
                                                onClick={() => cancelEdit()}
                                            >
                                                გაუქმება
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                style={buttonStyle}
                                                variant="contained"
                                                color="primary"
                                                onClick={() => startEditing(row.id, row.days, row.price)}
                                            >
                                                რედაქტირება
                                            </Button>
                                            <Button
                                                style={buttonStyle}
                                                variant="contained"
                                                color="error"
                                                onClick={() => handleDeleteRequest(row.id)}
                                                disabled={editingRowId !== null}
                                            >
                                                წაშლა
                                            </Button>
                                        </>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {showConfirmationModal && (
                <ConfirmationModal
                    isOpen={showConfirmationModal}
                    onRequestClose={() => setShowConfirmationModal(false)}
                    onConfirm={handleConfirm}
                />
            )}
            {showDeleteConfirmation && (
                <ConfirmationModal
                    isOpen={showDeleteConfirmation}
                    onRequestClose={() => setShowDeleteConfirmation(false)}
                    onConfirm={handleDeleteConfirm}
                />
            )}

            {alert.show && (
                <CustomAlert message={alert.message} type={alert.type} onClose={handleCloseAlert} />
            )}
        </>
    );
};

export default AddNewPermitTypePrice;
